import Button from "@material-ui/core/Button";
import Typeography from "@material-ui/core/Typography";
import React from "react";

const Success = ({
  discountCode,
  amount,
  currencyCode,
  handleReset,
  classes,
}) => {
  const ascii = btoa(
    JSON.stringify({ code: discountCode, amount: `£${parseInt(amount, 10)}` })
  );

  return (
    <div className="text-center">
      <Typeography title variant="title">
        All done, thanks!
      </Typeography>
      <Typeography paragraph>
        Check your inbox for instructions how to redeem it.
      </Typeography>
      <Button
        variant="contained"
        color="primary"
        href={`/giftcards/card/?code=${ascii}`}
      >
        Print Voucher
      </Button>
      &nbsp;
      <Button variant="outlined" color="secondary" onClick={handleReset}>
        Buy another!
      </Button>
    </div>
  );
};

export default Success;
